module.exports = __webpack_public_path__ + "banner_origin.c4cad99d.png";